import React, { HTMLAttributes } from "react";
import cn from "classnames";
import "./styles.scss";

type IGlassmorphicCardProps = HTMLAttributes<HTMLDivElement>;

export const GlassmorphicCard: React.FC<IGlassmorphicCardProps> = ({
  children,
  ...props
}) => (
  <div
    {...props}
    className={cn(
      "glassmorphic-card",
      props.className
    )}
  >
    {children}
  </div>
);
